import { getAreaAcresFromPolygons, type PolygonRings } from "../../utils/area.js";

/** Undefined when the zone has no mapped boundary. */
export const getAreaAcres = (zone: { polygons: PolygonRings }): number | undefined =>
    getAreaAcresFromPolygons(zone.polygons);
